const navigationRoutes = {
  NPS: "/nps",

  // Nps Overview
  NPS_OVERVIEW: "/finease/user/nps_overview",
  NPS_OVERVIEW_ROUTE: "/finease/user/nps_overview",

  DASHBOARD: "/finease/admin/dashboard",

  // Authentication
  LOGIN: "/nps",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_RESET: (id: string) => `/forgot-password-reset/${id}`,
  FORGOT_PASSWORD_RESET_ROUTE: "/forgot-password-reset/:id",

  // New Subscriber Registration
  NEW_SUBSCRIBER_REGISTRATION: "/new-subscriber-registration",
  SUBSCRIBER_REGISTRATION_SUMMARY: "/subscriber-registration-summary",

  // Digilocker Callback
  DIGILOCKER_CALLBACK: "/digilocker_callback",
  PRAN_SUCCESS_SCREEN: "/pran-success-screen",
  PAYMENT_FAILED_SCREEN: "/payment-failed-screen",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_AND_CONDITIONS: "/terms-and-conditions",
} as const;

export default navigationRoutes;
